import { IUserMilestone } from '../../IUserMilestone';

export const SEARCH_FILTER_PILL_INSIDER_BANNER_EUROPE =
  'SEARCH_FILTER_PILL_INSIDER_BANNER_EUROPE' as IUserMilestone.RetailerMilestone;
